__turbopack_context__.v({
  "big": "Collapse-module__DYR6lG__big",
  "border-bottom": "Collapse-module__DYR6lG__border-bottom",
  "border-top": "Collapse-module__DYR6lG__border-top",
  "container": "Collapse-module__DYR6lG__container",
  "header": "Collapse-module__DYR6lG__header",
  "icon": "Collapse-module__DYR6lG__icon",
  "minimal": "Collapse-module__DYR6lG__minimal",
  "regular": "Collapse-module__DYR6lG__regular",
  "small": "Collapse-module__DYR6lG__small",
  "title": "Collapse-module__DYR6lG__title",
});
